import React from 'react'
import { Alert, Heading } from '@livechat/design-system-react-components'

import { alertWrapperCss } from './styles'

interface IPaymentDeclinedAlertProps {
  error: string
}

const PaymentDeclinedAlert = ({ error }: IPaymentDeclinedAlertProps) => (
  <Alert kind="warning" css={alertWrapperCss} data-test="alert-wrapper">
    <Heading size="xs">Payment has been declined</Heading>
    {error}
  </Alert>
)

export default PaymentDeclinedAlert
